// Flash — site-wide behaviour. Everything works without it; this only polishes.
(() => {
  // Close open dropdowns (<details data-close-outside>) on outside click / Escape.
  const openDetails = () => document.querySelectorAll('details[data-close-outside][open]');
  document.addEventListener('click', (e) => {
    openDetails().forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    openDetails().forEach((d) => { d.removeAttribute('open'); d.querySelector('summary')?.focus(); });
  });

  // Lock page scroll while the mobile drawer is open.
  document.querySelectorAll('details.burger').forEach((d) => {
    d.addEventListener('toggle', () => { document.documentElement.style.overflow = d.open ? 'hidden' : ''; });
  });

  // Quantity steppers: [data-qty] wraps - / input / + buttons.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty] button');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const step = Number(btn.dataset.step || 0);
    const min = Number(input.min || 0);
    input.value = Math.max(min, (Number(input.value) || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Forms that submit themselves on change (cart quantities, filters, sorting, localization).
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[data-autosubmit]');
    if (!form) return;
    clearTimeout(form._t);
    form._t = setTimeout(() => (form.requestSubmit ? form.requestSubmit() : form.submit()), 450);
  });

  // Filters: drop empty params so URLs stay clean.
  document.querySelectorAll('form[data-filters]').forEach((form) => {
    form.addEventListener('formdata', (e) => {
      for (const [k, v] of [...e.formData.entries()]) if (v === '') e.formData.delete(k);
    });
  });

  // Scroll reveal: only for elements that start below the fold, so nothing visible
  // on load is ever hidden (no flash, no LCP delay). Siblings get a small stagger.
  const anim = document.documentElement.classList.contains('anim') &&
    !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window;
  if (anim) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    const sel = '.card,.tile,.step,.size,.quote,.usp,.faq details,.split__media,.cta,.gallery>*,.article-card,.row';
    document.querySelectorAll(sel).forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight) return;
      const i = [...el.parentElement.children].indexOf(el) % 6;
      el.style.setProperty('--d', `${i * 70}ms`);
      el.classList.add('rv');
      io.observe(el);
    });
    document.querySelectorAll('[data-wordmark]').forEach((el) => io.observe(el));
  }

  // Section videos: play only while on screen (saves data and battery on mobile).
  document.querySelectorAll('[data-autoplay] video').forEach((v) => {
    v.muted = true;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { v.controls = true; return; }
    if (!('IntersectionObserver' in window)) { v.play().catch(() => {}); return; }
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting) v.play().catch(() => {}); else v.pause();
    }, { threshold: 0.25 }).observe(v);
  });

  // Product media slider dots (mobile).
  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const dots = slider.parentElement.querySelectorAll('[data-dots] span');
    if (!dots.length) return;
    const paint = () => {
      const i = Math.round(slider.scrollLeft / slider.clientWidth);
      dots.forEach((d, n) => (d.style.background = n === i ? 'var(--accent)' : ''));
    };
    slider.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
    paint();
  });
})();
